import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { omit, pick } from 'lodash';

/**
 * ListCodeCategories
 *
 * Retrieves a list of code categories from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListCodeCategories = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = omit(payload?.[2], ['page', 'size', 'sort']);
    const thePagination = pick(payload?.[2], ['page', 'size', 'sort']);

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': '/code-lists/categories/search',
      },
      method: 'POST',
      params: { ...{ apiKey: theApiKey, queryKey: theQueryKey }, ...thePagination },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/Code/api/requests/queries/ListCodeCategories.js -> ListCodeCategories()', false, error);

    throw error;
  }
};
